import {
  createContext,
  type ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react'

import type { GetUserResponse } from '@/services/fintalk/services/fintalk-backoffice/users/get'

export type User = GetUserResponse

export interface UserContextProps {
  user: User | null
  setUser: (user: User) => void
  clearUser: () => void
}

const UserContext = createContext<UserContextProps | null>(null)

export function UserProvider({ children }: { children: ReactNode }) {
  const [user, setUserState] = useState<User | null>(null)

  const setUser = useCallback((user: User) => {
    setUserState(user)
  }, [])

  const clearUser = useCallback(() => {
    setUserState(null)
  }, [])

  return (
    <UserContext value={{ user, setUser, clearUser }}>{children}</UserContext>
  )
}

export const useUser = () => {
  const context = useContext(UserContext)

  if (!context) {
    throw new Error('useUser must be used within a UserProvider')
  }

  return context
}
